import React, { useEffect, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import Invitation from "./components/Invitation";
import PhotoGallery from "./components/PhotoGallery";

const App: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    const handleLoad = () => setIsLoaded(true);

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <div className={`app ${isLoaded ? "loaded" : "loading"}`}>
      {!isLoaded ? (
        <div className="preloader">
          <div className="progress-bar">
            <div className="progress"></div>
          </div>
        </div>
      ) : (
        <Router>
          <Routes>
            <Route
                path="/"
                element={<NavigateToExternal url="https://theknot.com/ashley-brant" />}
              />
            <Route path="/invitation" element={<Invitation />} />
            <Route path="/gallery" element={<PhotoGallery />} />
          </Routes>
        </Router>
      )}
    </div>
  );
};

const NavigateToExternal: React.FC<{ url: string }> = ({ url }) => {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null;
};

export default App;
